<template>
    <div id="step2">
        <div class="data-loading text-center mt-5" v-if="!packages">
            <font-awesome-icon pulse icon="spinner" size="3x"></font-awesome-icon>
        </div>

        <div v-if="packages && packages.length > 0">
            <HeadFoot title="Packages" v-on:back="back" v-on:clicked="next" button="Skip"></HeadFoot>

            <div class="mt-4">
                <h4 class="h2 font-light mt-3 text-center">Recommended Package</h4>
                <p class="text-center mb-3">Based on your selections, we recommend the following package:</p>

                <div class="data-loading text-center mt-5" v-if="loadingRecommended">
                    <font-awesome-icon pulse icon="spinner" size="3x"></font-awesome-icon>
                </div>
                <ViewPackage :package="recommended" recommended="true" color="bg-leonard-green hover:bg-leonard-green-hover" v-on:selectPackage="selectPackage" v-if="!loadingRecommended && recommended" class="mx-auto"></ViewPackage>

                <div class="rounded-md bg-yellow-50 p-4 mx-auto w-11/12 md:w-2/3" v-if="!loadingRecommended && !recommended">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                            </svg>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-sm leading-5 font-medium text-yellow-800">
                                Recommended Package Not Found
                            </h3>
                            <div class="mt-2 text-sm leading-5 text-yellow-700">
                                <p>Sorry, we could not gather a recommended package. You can choose a package below, or attempt to refresh the page and try again.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <h4 class="h2 mt-12 text-center">All Packages</h4>
                <p class="text-center mb-3">Click the details button to view more information about the package.</p>

                <div class="flex items-top justify-center flex-wrap">
                    <ViewPackage :package="pkg" color="bg-leonard-black hover:bg-leonard-black-hover" v-for="pkg in packages" :key="pkg.pkg_no" v-on:selectPackage="selectPackage"></ViewPackage>
                </div>
            </div>

            <HeadFoot v-on:back="back" v-on:clicked="next" button="Skip"></HeadFoot>
        </div>

    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSpinner } from '@fortawesome/free-solid-svg-icons';

    import Package from '../../classes/Package';
    import Cart from '../../classes/Cart';
    import Photo from '../../classes/Photo';

    import ViewPackage from '../../components/partials/Package';
    import HeadFoot from '../ordersteps/partials/StepHeaderFooter';

    export default {
        data() {
            return {
                Cart: new Cart(),
                Package: new Package(),
                Photo: new Photo(),
                access_code: localStorage.getItem('access_code'),
                con_no: localStorage.getItem('con_no'),
                loadingRecommended: true,
                favoriteCount: 0,
                recommended: null,
                packages: null,
                selected: null,
            }
        },

        components: {
            ViewPackage,
            HeadFoot
        },

        created() {
            library.add(faSpinner);

            if(this.access_code != null && this.con_no != null) {
                this.getPackages();
            } else {
                let alert = {
                    show: true,
                    level: 'danger',
                    text: 'No access code was found'
                }

                this.$emit('alertStatus', alert);
                this.$router.push({params: {step: null}});
            }
        },

        mounted() {
            window.events.$emit('updateProgress');
            document.title = 'Packages - ' + document.title;
        },

        methods: {
            selectPackage(pkg_no) {
                this.$router.push({params: {step: 'packages', package: pkg_no}});
            },

            getPackages() {
                let self = this;
                let data = {
                    con_no: this.con_no
                };

                this.Package.getAll(data).then(function(response) {
                    self.packages = response.data;
                    self.getFavoriteCount();
                })
            },

            getFavoriteCount() {
                let self = this;
                let data = {
                    con_no: this.con_no,
                    user_id: this.$auth.user().details.id
                };

                this.Photo.favorites(data).then(function(response) {
                    self.favoriteCount = response.data.length;
                    self.getRecommended(response.data.length);
                })
            },

            getRecommended(favoriteCount) {
                let self = this;
                let data = {
                    favorites: favoriteCount,
                    con_no: this.con_no
                };

                this.loadingRecommended = true;
                this.Package.getRecommended(data).then(function(response) {
                    self.loadingRecommended = false;

                    if(!response.success) {
                        feedback(response.message, 'danger');
                        return;
                    }

                    self.recommended = response.data;
                }).finally(function() {
                    window.events.$emit('finishedLoading');
                });
            },

            next() {
                this.$emit('nextStep');
            },

            back() {
                this.$emit('back', 'favorites');
            }
        },
    }
</script>
